const es = {
    actionAlready: "¿Aún no estás registrado? Inicia sesión",
    actionExit: "Cerrar sesión",
    actionLogin: "INICIAR SESIÓN",
    actionRegister: "REGISTRARSE",
    actionSave: "GUARDAR",
    actionStart: "INICIAR",
    actionContinue: "CONTINUAR",
    actionReset: "REINICIAR EVALUACIÓN",
    actionDoDiagnost: "MOSTRAR DIAGNÓSTICO",
    actionYes: "Sí",
    actionNo: "No",
    actionNext: "SIGUIENTE",
    actionBusinessCase: "MOSTRAR BUENA PRÁCTICA DE LA EMPRESA",
    actionBusinessCases: "MOSTRAR BUENAS PRÁCTICAS DE LAS EMPRESAS",
    actionOpenUrl: "ABRIR URL",
    actionFilter: "FILTRAR",

    /** HOME */
    msgHomeTitleOne: "Mide y aumenta el nivel de madurez circular de tu empresa de muebles",
    msgHomeSubTitle: "La herramienta en línea FurnCIRCLE evalúa el progreso de tu empresa hacia la madurez circular en función de las estrategias de diseño circular implementadas",

    msgHomeSection2: "Los requisitos de circularidad están en expansión.</br>¿Estás preparado?",
    msgHomeSection2Text: "<ul style='padding-left: 20px'><li>Responde las preguntas sobre las estrategias de diseño circular actualmente implementadas en tu empresa.</li><li>Obtén el índice de madurez circular de tu empresa.</li><li>Identifica estrategias de diseño y buenas prácticas de empresas para llevar tu empresa al siguiente nivel.</li><li>Aprende de las buenas prácticas de empresas reales para seguir mejorando el nivel de madurez circular de tu empresa.</li></ul>",
    msgHomeSection3: "Socios",
    msgHomeSection2Btn: "Comienza tu evaluación",
    msgHomeSection3Btn: "CONTACTO",

    /** HEADER */
    msgHeader1: "Estrategias de diseño circular y buenas prácticas",
    msgHeader4: "Iniciar sesión",

    /** DRAWER */
    msgCompany: "EMPRESA",
    msgDrawer1: "1. Responder",
    msgDrawer2: "2. Evaluar",
    msgDrawer3: "3. Mejorar",
    msgDrawer4: "Colección de estrategias",
    msgDrawer6: "Configuración",
    msgDrawer7: "Cerrar sesión",

    /** LOGIN */
    msgWelcome: "Bienvenido",
    msgWelcomeSubtitle: "Por favor, inicia sesión para continuar",

    /** REGISTER */
    msgGetStarted: "Comenzar",
    msgGetStartedSubtitle: "Esta herramienta de autoevaluación es gratuita y confidencial",

    msgFirstname: "Nombre",
    msgLastname: "Apellido",
    msgEmail: "Correo electrónico",
    msgPassword: "Contraseña",
    msgConfirmPassword: "Confirmar contraseña",
    msgCompanyUser: "Empresa o nombre de usuario",

    msgNotRegister: "¿Aún no estás registrado? <b>Crea una cuenta aquí</b>",
    msgAlreadyRegister: "¿Ya estás registrado? <b>Inicia sesión aquí</b>",

    /** HOME TOOL */
    msgClickImage: "Haz clic para ampliar el sistema de modelo lineal versus circular.",

    msgArea: "ÁREA",
    msgProgress: "PREGUNTAS RESPONDIDAS",

    msgAssessmentAreas: "Estrategias de Diseño Circular y Ciclo de Vida del Producto",
    msgAssessmentDesc: "Las estrategias de diseño circular se aplican durante la fase de diseño y desarrollo de productos, aunque su impacto (positivo) puede ocurrir en una o más fases posteriores del ciclo de vida del producto. Por lo tanto, una forma de clasificar las estrategias de diseño circular es según la etapa del ciclo de vida impactada: diseño, recursos materiales, producción, distribución, uso y fin de vida.<br/><br/><span style=\"font-weight:bold; font-size:16px;\">Por favor, responde todas las preguntas de cada bloque o fase del ciclo de vida, determina tu nivel de madurez circular y planifica tu mejora y transición hacia una economía más circular.</span>",

    msgAssessment: "Evaluación FurnCIRCLE",
    msgNotApply: "Marca todas las respuestas que correspondan al desempeño circular actual de tu empresa. Las respuestas se guardan automáticamente.",
    msgMarkImportant: "Marcar como importante",
    msgComment: "Comentario",
    msgCommentHolder: "Puedes escribir aquí cualquier información relacionada o tus propios comentarios.",

    /** ANSWER */
    msgPerformance: "Informe de Evaluación",
    msgPerformanceSubtitle: "Consulta el índice de madurez circular de tu empresa y de cada fase del ciclo de vida de tus productos.",
    msgCompanyLevel: "Índice de madurez circular de tu empresa (0%-100%)",
    msgBlockArea: "FASE DEL CICLO DE VIDA",
    msgBlockValues: "VALORES",

    /** ASSESS */
    msgImprovement: "Informe de Mejora",
    msgImprovementMainSubtitle: "Aprende qué puedes hacer para mejorar continuamente la circularidad de tu empresa. Conoce estrategias de diseño y buenas prácticas de empresas para llevar tu empresa al siguiente nivel.</br></br>Las fases del ciclo de vida y estrategias de diseño circular con una etiqueta/círculo “rojo” tienen un nivel de desempeño igual o inferior al 25% de su valor máximo y, por lo tanto, pueden considerarse una prioridad principal para mejorar la circularidad de la empresa. Las fases o estrategias con una etiqueta/círculo “naranja” tienen un nivel de desempeño superior al 25% y menor o igual al 75%, por lo que también es importante abordar su mejora. Las fases o estrategias con una etiqueta/círculo “verde” tienen un nivel de desempeño superior al 75% y, por lo tanto, son menos prioritarias para la mejora.",
    msgImprovementSubtitle: "Aprende qué puedes hacer para mejorar continuamente la circularidad de tu empresa. Conoce estrategias de diseño y buenas prácticas de empresas para llevar tu empresa al siguiente nivel.",
    msgLifecyclePhases: "Fases del ciclo de vida",
    msgLifecycleIndex: "Índice de circularidad de la fase",
    msgActionsToImplement: "Acciones a implementar:",
    msgBaselineScore: "Mi puntuación base",
    msgBusinessCaseEmpty: "¡Felicidades! Ya has implementado las principales estrategias incluidas en esta categoría",

    msgCat1: "ECONÓMICO Y ORGANIZACIONAL",
    msgCat2: "SOCIAL",
    msgCat3: "AMBIENTAL",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Explora y descubre la colección completa de estrategias de diseño circular y buenas prácticas de empresas del proyecto FurnCIRCLE.",
    msgLifecyclePhase: "Fase del ciclo de vida",
    msgDifficulty: "Dificultad de implementación",
    msgBusinessDynamics: "Generación o entrega de valor",
    msgBusinessFactors: "Propuesta de valor / Costos / Beneficios",

    /** SETTINGS */
    msgUserInfo: "Información del usuario",
    msgUserCredentials: "Credenciales del usuario",

    /** MODAL */
    msgAreSure: "¿Estás seguro?",

    msgSuccess: "Datos actualizados con éxito",
    msgDeleteSuccess: "Datos eliminados con éxito",

    /** ALT TEXT */
    msgSaveCommentAlt: "Guarda el “Comentario”. No es necesario guardar las respuestas a las preguntas; se guardan automáticamente.",
    msgDifficultyAlt: "Esta etiqueta indica la dificultad de implementar la estrategia de diseño circular.",
    msgBusinessBlockAlt: "Esta etiqueta indica qué bloque de negocio del modelo CANVAS (Generación de Valor o Entrega de Valor) se ve afectado por la implementación de la estrategia de diseño circular.",
    msgImpactBlockAlt: "Esta etiqueta indica qué bloque de impacto del modelo CANVAS (Costos, Beneficios o Propuesta de Valor) se ve afectado por la implementación de la estrategia de diseño circular.",

    /** ERROR */
    errorOblData: "Rellena todos los campos obligatorios",
    errorEmailFormat: "Error en el formato del correo electrónico",
    errorUserIncorrect: "Correo/contraseña incorrectos",
    errorSend: "Error de comunicación, por favor espera e inténtalo de nuevo más tarde",
    errorLength: "Se ha excedido el número de caracteres",
    errorPassSame: "Las contraseñas no coinciden",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Recuperación de contraseña",
    msgRecoveryPasswordSubtitle: "Por favor, introduce tu dirección de correo electrónico para recibir un código de restablecimiento de contraseña.",
    msgCode: "Código",
    msgNewPassword: "Nueva contraseña",
    actionRequestCode: "SOLICITAR CÓDIGO",
    actionUpdate: "ACTUALIZAR",
    actionBack: "VOLVER",
    msgForgetPassword: "¿Olvidaste tu contraseña?",
    errorRecovery: "Error en la recuperación de contraseña, por favor verifica el código proporcionado",

    /** FOOTER */
    msgFooterContact: "CONTACTO",

    msgFooterGr: "Financiado por la Unión Europea. Las opiniones expresadas son únicamente las del autor(es) y no reflejan necesariamente las de la Unión Europea. Ni la Unión Europea ni la autoridad otorgante pueden ser responsables de ellas. Convocatoria y referencia del acuerdo de subvención: SOCPL-2022-SOC-DIALOG-01 (Proyecto 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. Todos los derechos reservados",

    msgFooterLegal: "Aviso legal",
    msgFooterPrivacy: "Privacidad",
    msgFooterCookies: "Política de cookies",

    /** PROGRESS VALUES */
    msgProgress0: "Estrategias de diseño circular",

    /** COMPANY SIZES */
    msgCompanySize: "Tamaño de la empresa",
    msgCompanySize1: "Menos de 10 empleados",
    msgCompanySize2: "10-30 empleados",
    msgCompanySize3: "30-50 empleados",
    msgCompanySize4: "Más de 50 empleados",

    /** PRODUCT TYPES */
    msgProductType: "Tipo de productos que fabricas",
    msgProductType1: "Tapicería",
    msgProductType2: "Colchones",
    msgProductType3: "Bases tapizadas, canapés, somieres",
    msgProductType4: "Subcontratista (armazones, mecanizado, barnizado, etc.)",
    msgProductType5: "Servicios (logística especializada, etc.)",
    msgProductType6: "Muebles de tablero (melamina, chapa, laca, etc.)",
    msgProductType7: "Muebles de madera",
    msgProductType8: "Sillas",
    msgProductType9: "Muebles de oficina",
    msgProductType10: "Mobiliario para espacios y usos públicos",
    msgProductType11: "Puertas, ventanas y productos de carpintería",
    msgProductType12: "Instalaciones a medida (tiendas, bibliotecas, restaurantes, negocios profesionales, etc.)",
    msgProductType13: "Iluminación",
    msgProductType14: "Revestimientos y suelos",
    msgProductType15: "Textil",
    msgProductType16: "Decoración",

    /* COUNTRIES */
    msgCountry: "País",
    msgAfghanistan: "Afganistán",
    msgAlbania: "Albania",
    msgAlgeria: "Argelia",
    msgAmericanSamoa: "Samoa Americana",
    msgAndorra: "Andorra",
    msgAngola: "Angola",
    msgAnguilla: "Anguila",
    msgAntarctica: "Antártida",
    msgAntiguaandBarbuda: "Antigua y Barbuda",
    msgArgentina: "Argentina",
    msgArmenia: "Armenia",
    msgAruba: "Aruba",
    msgAustralia: "Australia",
    msgAustria: "Austria",
    msgAzerbaijan: "Azerbaiyán",
    msgBahamas: "Bahamas",
    msgBahrain: "Baréin",
    msgBangladesh: "Bangladés",
    msgBarbados: "Barbados",
    msgBelarus: "Bielorrusia",
    msgBelgium: "Bélgica",
    msgBelize: "Belice",
    msgBenin: "Benín",
    msgBermuda: "Bermudas",
    msgBhutan: "Bután",
    msgBolivia: "Bolivia",
    msgBosniaHerzegovina: "Bosnia y Herzegovina",
    msgBotswana: "Botsuana",
    msgBouvetIsland: "Isla Bouvet",
    msgBrazil: "Brasil",
    msgBritishIndian: "Territorio Británico del Océano Índico",
    msgBrunei: "Brunéi",
    msgBulgaria: "Bulgaria",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Camboya",
    msgCameroon: "Camerún",
    msgCanada: "Canadá",
    msgCapeVerde: "Cabo Verde",
    msgCaymanIslands: "Islas Caimán",
    msgCentralAfrican: "República Centroafricana",
    msgChad: "Chad",
    msgChile: "Chile",
    msgChina: "China",
    msgChristmasIsland: "Isla de Navidad",
    msgCocosIslands: "Islas Cocos (Keeling)",
    msgColombia: "Colombia",
    msgComoros: "Comoras",
    msgCongo: "Congo",
    msgRepublicCongo: "República Democrática del Congo",
    msgCookIslands: "Islas Cook",
    msgCostaRica: "Costa Rica",
    msgIvoryCoast: "Costa de Marfil",
    msgCroatia: "Croacia",
    msgCuba: "Cuba",
    msgCyprus: "Chipre",
    msgCzechRepublic: "República Checa",
    msgDenmark: "Dinamarca",
    msgDjibouti: "Yibuti",
    msgDominica: "Dominica",
    msgDominicanRepublic: "República Dominicana",
    msgEastTimor: "Timor Oriental",
    msgEcuador: "Ecuador",
    msgEgypt: "Egipto",
    msgEngland: "Inglaterra",
    msgElSalvador: "El Salvador",
    msgEquatorialGuinea: "Guinea Ecuatorial",
    msgEritrea: "Eritrea",
    msgEstonia: "Estonia",
    msgEthiopia: "Etiopía",
    msgFalklandIslands: "Islas Malvinas",
    msgFaroeIslands: "Islas Feroe",
    msgFijiIslands: "Islas Fiyi",
    msgFinland: "Finlandia",
    msgFrance: "Francia",
    msgFrenchGuiana: "Guayana Francesa",
    msgFrenchPolynesia: "Polinesia Francesa",
    msgFrenchSouthern: "Territorios Australes Franceses",
    msgGabon: "Gabón",
    msgGambia: "Gambia",
    msgGeorgia: "Georgia",
    msgGermany: "Alemania",
    msgGhana: "Ghana",
    msgGibraltar: "Gibraltar",
    msgGreece: "Grecia",
    msgGreenland: "Groenlandia",
    msgGrenada: "Granada",
    msgGuadeloupe: "Guadalupe",
    msgGuam: "Guam",
    msgGuatemala: "Guatemala",
    msgGuernsey: "Guernesey",
    msgGuinea: "Guinea",
    msgGuineaBissau: "Guinea-Bisáu",
    msgGuyana: "Guyana",
    msgHaiti: "Haití",
    msgHeardMcDonald: "Islas Heard y McDonald",
    msgHolySee: "Santa Sede (Estado de la Ciudad del Vaticano)",
    msgHonduras: "Honduras",
    msgHongKong: "Hong Kong",
    msgHungary: "Hungría",
    msgIceland: "Islandia",
    msgIndia: "India",
    msgIndonesia: "Indonesia",
    msgIran: "Irán",
    msgIraq: "Irak",
    msgIreland: "Irlanda",
    msgIsrael: "Israel",
    msgIsleMan: "Isla de Man",
    msgItaly: "Italia",
    msgJamaica: "Jamaica",
    msgJapan: "Japón",
    msgJersey: "Jersey",
    msgJordan: "Jordania",
    msgKazakhstan: "Kazajistán",
    msgKenya: "Kenia",
    msgKiribati: "Kiribati",
    msgKuwait: "Kuwait",
    msgKyrgyzstan: "Kirguistán",
    msgLaos: "Laos",
    msgLatvia: "Letonia",
    msgLebanon: "Líbano",
    msgLesotho: "Lesoto",
    msgLiberia: "Liberia",
    msgLibyanJamahiriya: "Libia",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Lituania",
    msgLuxembourg: "Luxemburgo",
    msgMacao: "Macao",
    msgNorthMacedonia: "Macedonia del Norte",
    msgMadagascar: "Madagascar",
    msgMalawi: "Malaui",
    msgMalaysia: "Malasia",
    msgMaldives: "Maldivas",
    msgMali: "Malí",
    msgMalta: "Malta",
    msgMarshallIslands: "Islas Marshall",
    msgMartinique: "Martinica",
    msgMauritania: "Mauritania",
    msgMauritius: "Mauricio",
    msgMayotte: "Mayotte",
    msgMexico: "México",
    msgMicronesia: "Micronesia, Estados Federados de",
    msgMoldova: "Moldavia",
    msgMonaco: "Mónaco",
    msgMongolia: "Mongolia",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Montenegro",
    msgMorocco: "Marruecos",
    msgMozambique: "Mozambique",
    msgMyanmar: "Myanmar",
    msgNamibia: "Namibia",
    msgNauru: "Nauru",
    msgNepal: "Nepal",
    msgNetherlands: "Países Bajos",
    msgNetherlandsAntilles: "Antillas Neerlandesas",
    msgNewCaledonia: "Nueva Caledonia",
    msgNewZealand: "Nueva Zelanda",
    msgNicaragua: "Nicaragua",
    msgNiger: "Níger",
    msgNigeria: "Nigeria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Isla Norfolk",
    msgNorthKorea: "Corea del Norte",
    msgNorthernIreland: "Irlanda del Norte",
    msgNorthernMariana: "Islas Marianas del Norte",
    msgNorway: "Noruega",
    msgOman: "Omán",
    msgPakistan: "Pakistán",
    msgPalau: "Palaos",
    msgPalestine: "Palestina",
    msgPanama: "Panamá",
    msgPapua: "Papúa Nueva Guinea",
    msgParaguay: "Paraguay",
    msgPeru: "Perú",
    msgPhilippines: "Filipinas",
    msgPitcairn: "Pitcairn",
    msgPoland: "Polonia",
    msgPortugal: "Portugal",
    msgPuertoRico: "Puerto Rico",
    msgQatar: "Catar",
    msgReunion: "Reunión",
    msgRomania: "Rumania",
    msgRussianFederation: "Federación Rusa",
    msgRwanda: "Ruanda",
    msgSaintHelena: "Santa Elena",
    msgSaintKitts: "San Cristóbal y Nieves",
    msgSaintLucia: "Santa Lucía",
    msgSaintPierre: "San Pedro y Miquelón",
    msgSaintVincent: "San Vicente y las Granadinas",
    msgSamoa: "Samoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "Santo Tomé y Príncipe",
    msgSaudiArabia: "Arabia Saudita",
    msgScotland: "Escocia",
    msgSenegal: "Senegal",
    msgSerbia: "Serbia",
    msgSeychelles: "Seychelles",
    msgSierraLeone: "Sierra Leona",
    msgSingapore: "Singapur",
    msgSlovakia: "Eslovaquia",
    msgSlovenia: "Eslovenia",
    msgSolomonIslands: "Islas Salomón",
    msgSomalia: "Somalia",
    msgSouthAfrica: "Sudáfrica",
    msgSouthSandwich: "Georgia del Sur y las Islas Sandwich del Sur",
    msgSouthKorea: "Corea del Sur",
    msgSouthSudan: "Sudán del Sur",
    msgSpain: "España",
    msgSriLanka: "Sri Lanka",
    msgSudan: "Sudán",
    msgSuriname: "Surinam",
    msgSvalbardJan: "Svalbard y Jan Mayen",
    msgSwaziland: "Suazilandia",
    msgSweden: "Suecia",
    msgSwitzerland: "Suiza",
    msgSyria: "Siria",
    msgTajikistan: "Tayikistán",
    msgTanzania: "Tanzania",
    msgThailand: "Tailandia",
    msgTimorLeste: "Timor-Leste",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinidad y Tobago",
    msgTunisia: "Túnez",
    msgTurkey: "Turquía",
    msgTurkmenistan: "Turkmenistán",
    msgTurksCaicos: "Islas Turcas y Caicos",
    msgTuvalu: "Tuvalu",
    msgUganda: "Uganda",
    msgUkraine: "Ucrania",
    msgUnitedArabEmirates: "Emiratos Árabes Unidos",
    msgUnitedKingdom: "Reino Unido",
    msgUnitedStates: "Estados Unidos",
    msgUnitedStatesMinor: "Islas Menores de los Estados Unidos",
    msgUruguay: "Uruguay",
    msgUzbekistan: "Uzbekistán",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venezuela",
    msgVietnam: "Vietnam",
    msgVirginIslandsBritish: "Islas Vírgenes Británicas",
    msgVirginIslandsUS: "Islas Vírgenes de los EE. UU.",
    msgWales: "Gales",
    msgWallisFutuna: "Wallis y Futuna",
    msgWesternSahara: "Sáhara Occidental",
    msgYemen: "Yemen",
    msgZambia: "Zambia",
    msgZimbabwe: "Zimbabue",
}

export default es;